import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link, useHistory, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import { Modal, Button } from "react-bootstrap";

function CrearPresupuesto() {
    const location = useLocation();
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    
    // Estados del formulario
    const [fechaCreacion, setFechaCreacion] = useState(new Date().toISOString().split('T')[0]);
    const [fechaVence, setFechaVence] = useState(new Date().toISOString().split('T')[0]);
    const [numeroPresupuesto, setNumeroPresupuesto] = useState('');
    const [formaPago, setFormaPago] = useState('Efectivo');
    
    // Estados del paciente
    const [pacienteId, setPacienteId] = useState('');
    const [nombrePaciente, setNombrePaciente] = useState('');
    const [tipoPaciente, setTipoPaciente] = useState('CC');
    const [documentoPaciente, setDocumentoPaciente] = useState('');
    
    // Estados de productos
    const [productos, setProductos] = useState([]);
    const [productoSeleccionado, setProductoSeleccionado] = useState('');
    const [valorBruto, setValorBruto] = useState(0);
    const [valorTotal, setValorTotal] = useState(0);
    
    // Estados para lista de precios
    const [listaPrecios, setListaPrecios] = useState([]);
    const [clasificacionFiltro, setClasificacionFiltro] = useState('');
    const [especialidades, setEspecialidades] = useState([]);
    const [impuestos, setImpuestos] = useState([]);
    
    const [observaciones, setObservaciones] = useState('');
    const [showModalPaciente, setShowModalPaciente] = useState(false);
    const [pacientes, setPacientes] = useState([]);
    const [busquedaPaciente, setBusquedaPaciente] = useState('');
    const [paginaActual, setPaginaActual] = useState(1);
    const pacientesPorPagina = 10;

    // Estados para modal de éxito
    const [showModalExito, setShowModalExito] = useState(false);
    const [numeroPresupuestoCreado, setNumeroPresupuestoCreado] = useState('');
    const history = useHistory();

    useEffect(() => {
        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar pacientes
        axios.get('/pacientes?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setPacientes(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar especialidades
        axios.get('/especialidades-referencia?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setEspecialidades(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar lista de precios
        axios.get('/lista-precios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setListaPrecios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        // Cargar impuestos (tabla maestra - sin filtro por client_id)
        axios.get('/administrador-impuestos', config)
            .then(response => {
                if (response.status === 200) {
                    setImpuestos(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    }, []);

    // Cargar datos del paciente si viene desde EstadoCuentaPaciente
    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const pacienteIdUrl = urlParams.get('paciente_id');
        
        console.log('Paciente ID desde URL:', pacienteIdUrl);
        
        if (pacienteIdUrl && loggedIn) {
            cargarDatosPaciente(pacienteIdUrl);
        }
    }, [location.search, loggedIn]);

    const cargarDatosPaciente = async (pacienteIdParam) => {
        console.log('Cargando datos del paciente ID:', pacienteIdParam);
        let userdata = JSON.parse(localStorage.getItem('userdata'));

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        try {
            // Cargar datos del paciente
            const pacienteResponse = await axios.get(`/paciente?uid=${userdata.user_id}&id=${pacienteIdParam}`, config);
            const pacienteData = pacienteResponse.data[0];
            
            if (pacienteData) {
                // Establecer datos del paciente
                const nombreCompleto = `${pacienteData.primer_nombre || ''} ${pacienteData.segundo_nombre || ''} ${pacienteData.primer_apellido || ''} ${pacienteData.segundo_apellido || ''}`.trim();
                
                setPacienteId(pacienteIdParam);
                setNombrePaciente(nombreCompleto);
                setTipoPaciente(pacienteData.tipo_documento || 'CC');
                setDocumentoPaciente(pacienteData.numero_documento || '');
                
                console.log('Datos del paciente cargados:', nombreCompleto);
            }
        } catch (error) {
            console.error('Error al cargar datos del paciente:', error);
        }
    };

    const getListaPreciosFiltrada = () => {
        if (!clasificacionFiltro) {
            return listaPrecios;
        }
        
        return listaPrecios.filter(item => {
            return item.clasificacion === clasificacionFiltro;
        });
    };

    const agregarServicio = () => {
        const servicio = listaPrecios.find(s => s.id == productoSeleccionado);
        if (servicio) {
            const nuevoProducto = {
                id: Date.now(),
                id_listadeprecios: servicio.id,
                codigo: servicio.codigo,
                clasificacion: servicio.clasificacion || '',
                descripcion: servicio.nombre,
                cantidad: 1,
                precio: parseFloat(servicio.precio),
                porcentaje: 0,
                impuesto: 0,
                total: parseFloat(servicio.precio)
            };
            setProductos([...productos, nuevoProducto]);
            calcularTotales([...productos, nuevoProducto]);
            setProductoSeleccionado('');
        }
    };

    const eliminarProducto = (id) => {
        const nuevosProductos = productos.filter(p => p.id !== id);
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const actualizarProducto = (id, campo, valor) => {
        const nuevosProductos = productos.map(p => {
            if (p.id === id) {
                const productoActualizado = { ...p, [campo]: parseFloat(valor) || 0 };
                
                // Recalcular total del producto
                const descuento = (productoActualizado.precio * productoActualizado.cantidad) * (productoActualizado.porcentaje / 100);
                const totalBase = (productoActualizado.precio * productoActualizado.cantidad) - descuento;
                const totalConImpuesto = totalBase + (totalBase * (productoActualizado.impuesto / 100));
                productoActualizado.total = totalConImpuesto;
                
                return productoActualizado;
            }
            return p;
        });
        setProductos(nuevosProductos);
        calcularTotales(nuevosProductos);
    };

    const calcularTotales = (productosArray) => {
        let subtotal = 0;
        let totalDescuentos = 0;
        let totalImpuestos = 0;
        let total = 0;

        productosArray.forEach(producto => {
            const precioBase = producto.precio * producto.cantidad;
            const descuento = precioBase * (producto.porcentaje / 100);
            const baseConDescuento = precioBase - descuento;
            const impuesto = baseConDescuento * (producto.impuesto / 100);
            
            subtotal += precioBase;
            totalDescuentos += descuento;
            totalImpuestos += impuesto;
            total += producto.total;
        });

        setValorBruto(subtotal);
        setValorTotal(total);
    };

    const getPacientesFiltrados = () => {
        if (!busquedaPaciente) return pacientes;
        
        return pacientes.filter(paciente => {
            const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim().toLowerCase();
            const documento = paciente.numero_documento || '';
            const busqueda = busquedaPaciente.toLowerCase();
            
            return nombreCompleto.includes(busqueda) || documento.includes(busqueda);
        });
    };

    const getPacientesPaginados = () => {
        const pacientesFiltrados = getPacientesFiltrados();
        const inicio = (paginaActual - 1) * pacientesPorPagina;
        const fin = inicio + pacientesPorPagina;
        return pacientesFiltrados.slice(inicio, fin);
    };

    const getTotalPaginas = () => {
        return Math.ceil(getPacientesFiltrados().length / pacientesPorPagina);
    };

    const seleccionarPaciente = (paciente) => {
        const nombreCompleto = `${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim();
        setPacienteId(paciente.id);
        setNombrePaciente(nombreCompleto);
        setTipoPaciente(paciente.tipo_documento || 'CC');
        setDocumentoPaciente(paciente.numero_documento || '');
        setShowModalPaciente(false);
    };

    // Funciones para modal de éxito
    const handleShowModalExito = () => setShowModalExito(true);
    const handleCloseModalExito = () => setShowModalExito(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!pacienteId) {
            alert('Por favor seleccione un paciente');
            return;
        }
        
        if (productos.length === 0) {
            alert('Debe agregar al menos un servicio');
            return;
        }

        let userdata = JSON.parse(localStorage.getItem('userdata'));
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token,
                'Content-Type': 'application/json'
            }
        };

        const presupuestoData = {
            users_id: userdata.user_id,
            paciente_id: parseInt(pacienteId),
            client_id: client.client_id,
            fecha_creacion: fechaCreacion,
            fecha_vence: fechaVence,
            forma_pago: formaPago,
            valor_bruto: parseFloat(valorBruto),
            valor_total: parseFloat(valorTotal),
            observaciones: observaciones || '',
            detalle: productos.map(producto => ({
                id_listadeprecios: parseInt(producto.id_listadeprecios),
                cantidad: parseInt(producto.cantidad),
                precio_unitario: parseFloat(producto.precio),
                porcentaje: parseFloat(producto.porcentaje),
                impuesto: parseFloat(producto.impuesto),
                total: parseFloat(producto.total)
            }))
        };

        try {
            const response = await axios.post('/presupuesto', presupuestoData, config);
            if (response.status === 200 || response.status === 201) {
                // Guardar número de presupuesto creado
                setNumeroPresupuestoCreado(response.data.numero_presupuesto);
                
                // Limpiar formulario
                setProductos([]);
                setPacienteId('');
                setNombrePaciente('');
                setDocumentoPaciente('');
                setObservaciones('');
                setValorBruto(0);
                setValorTotal(0);
                setNumeroPresupuesto('');
                
                // Mostrar modal de éxito
                setTimeout(() => { handleShowModalExito() }, 500);
            }
        } catch (error) {
            console.error('Error completo:', error);
            alert('Error al guardar el presupuesto: ' + (error.response?.data?.message || error.message));
        }
    };

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="billing" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left">
                                        <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/menu-facturacion">Contabilidad</Link></li>
                                        <li className="breadcrumb-item"><Link to="/listado-presupuestos">Listado de Presupuestos</Link></li>
                                        <li className="breadcrumb-item active">Crear Presupuesto</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Crear Presupuesto</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            
                            <div className="card card-info card-outline">
                                <div className="card card-info-outline">
                                    <div className="card-header">
                                        <h5><b>Información del Presupuesto</b></h5>
                                    </div>
                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            
                                            <h5><b>Información del Paciente</b></h5>
                                            
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Nombre *</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={nombrePaciente}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-2">
                                                    <div className="form-group">
                                                        <label>Tipo *</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={tipoPaciente}
                                                            readOnly
                                                            required
                                                        >
                                                            <option value="CC">CC</option>
                                                            <option value="CE">CE</option>
                                                            <option value="PA">PA</option>
                                                            <option value="PE">PE</option>
                                                            <option value="RC">RC</option>
                                                            <option value="TI">TI</option>
                                                            <option value="NIT">NIT</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="form-group">
                                                        <label>N° Documento *</label>
                                                        <input 
                                                            type="text" 
                                                            className="form-control" 
                                                            value={documentoPaciente}
                                                            readOnly
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-1">
                                                    <div className="form-group">
                                                        <label>&nbsp;</label>
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-info form-control"
                                                            onClick={() => setShowModalPaciente(true)}
                                                        >
                                                            <i className="fas fa-search"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Fecha de Creación *</label>
                                                        <input 
                                                            type="date" 
                                                            className="form-control" 
                                                            value={fechaCreacion}
                                                            onChange={(e) => setFechaCreacion(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>Fecha de Vencimiento *</label>
                                                        <input 
                                                            type="date" 
                                                            className="form-control" 
                                                            value={fechaVence}
                                                            onChange={(e) => setFechaVence(e.target.value)}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            <div className="form-group">
                                                {/* Primera fila: Clasificación */}
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <label>Clasificación</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={clasificacionFiltro}
                                                            onChange={(e) => setClasificacionFiltro(e.target.value)}
                                                        >
                                                            <option value="">Todas</option>
                                                            {especialidades.map(esp => (
                                                                <option key={esp.id} value={esp.nombre}>{esp.nombre}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                
                                                {/* Segunda fila: Selector de servicio + Botón */}
                                                <div className="row mt-2">
                                                    <div className="col-md-10">
                                                        <label>Selecciona el Servicio</label>
                                                        <select 
                                                            className="form-control" 
                                                            value={productoSeleccionado}
                                                            onChange={(e) => setProductoSeleccionado(e.target.value)}
                                                        >
                                                            <option value="">Seleccionar...</option>
                                                            {getListaPreciosFiltrada().map(servicio => (
                                                                <option key={servicio.id} value={servicio.id}>
                                                                    {servicio.codigo} - {servicio.nombre}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label>&nbsp;</label>
                                                        <button 
                                                            type="button" 
                                                            className="btn btn-info btn-block"
                                                            onClick={agregarServicio}
                                                        >
                                                            Agregar Servicio
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <hr />

                                            {/* Tabla de productos */}
                                            <div className="table-responsive" style={{overflowX: 'auto'}}>
                                                <table className="table table-bordered table-hover" style={{minWidth: '900px'}}>
                                                    <thead>
                                                        <tr>
                                                            <th style={{width: '12%', minWidth: '100px'}}>Clasificación</th>
                                                            <th style={{width: '25%', minWidth: '150px'}}>Descripción</th>
                                                            <th style={{width: '8%', minWidth: '70px'}}>Cant.</th>
                                                            <th style={{width: '12%', minWidth: '100px'}}>Precio</th>
                                                            <th style={{width: '8%', minWidth: '70px'}}>Desc %</th>
                                                            <th style={{width: '13%', minWidth: '110px'}}>Impuesto</th>
                                                            <th style={{width: '15%', minWidth: '120px'}}>Total</th>
                                                            <th style={{width: '7%', minWidth: '60px'}}>Acción</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {productos.map(producto => (
                                                            <tr key={producto.id}>
                                                                <td>{producto.clasificacion || 'N/A'}</td>
                                                                <td>{producto.descripcion}</td>
                                                                <td>
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.cantidad}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'cantidad', e.target.value)}
                                                                        min="1"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.precio}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'precio', e.target.value)}
                                                                        step="0.01"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input 
                                                                        type="number" 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.porcentaje}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'porcentaje', e.target.value)}
                                                                        min="0"
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <select 
                                                                        className="form-control form-control-sm" 
                                                                        value={producto.impuesto}
                                                                        onChange={(e) => actualizarProducto(producto.id, 'impuesto', e.target.value)}
                                                                    >
                                                                        <option value="0">0</option>
                                                                        {impuestos.map(imp => (
                                                                            <option key={imp.id} value={imp.impuesto}>{imp.nombre+' '+imp.impuesto+'%'}</option>
                                                                        ))}
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <input 
                                                                        type="text" 
                                                                        className="form-control form-control-sm" 
                                                                        value={parseFloat(producto.total || 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                        readOnly
                                                                    />
                                                                </td>
                                                                <td style={{textAlign: 'center'}}>
                                                                    <button 
                                                                        type="button" 
                                                                        className="fas fa-trash-alt btn btn-danger btn-sm"
                                                                        onClick={() => eliminarProducto(producto.id)}
                                                                    >
                                                                        
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                    <tfoot>
                                                        <tr style={{borderTop: '2px solid #dee2e6'}}>
                                                            <td colSpan="6" className="text-right" style={{border: 'none', paddingTop: '15px'}}><strong>Subtotal:</strong></td>
                                                            <td colSpan="2" style={{border: 'none', paddingTop: '15px'}}>
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control" 
                                                                    value={'$ ' + parseFloat(valorBruto || 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                    readOnly
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="6" className="text-right" style={{border: 'none'}}><strong>Descuento:</strong></td>
                                                            <td colSpan="2" style={{border: 'none'}}>
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control" 
                                                                    value={'$ ' + productos.reduce((sum, p) => sum + ((p.precio * p.cantidad) * (p.porcentaje / 100)), 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                    readOnly
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="6" className="text-right" style={{border: 'none'}}><strong>IVA:</strong></td>
                                                            <td colSpan="2" style={{border: 'none'}}>
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control" 
                                                                    value={'$ ' + productos.reduce((sum, p) => {
                                                                        const baseConDescuento = (p.precio * p.cantidad) - ((p.precio * p.cantidad) * (p.porcentaje / 100));
                                                                        return sum + (baseConDescuento * (p.impuesto / 100));
                                                                    }, 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                    readOnly
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="6" className="text-right" style={{border: 'none'}}><strong>Total:</strong></td>
                                                            <td colSpan="2" style={{border: 'none'}}>
                                                                <input 
                                                                    type="text" 
                                                                    className="form-control" 
                                                                    value={'$ ' + parseFloat(valorTotal || 0).toLocaleString('es-CO', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                    readOnly
                                                                />
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>

                                            <hr />

                                            <div className="form-group">
                                                <label>Observaciones</label>
                                                <textarea 
                                                    className="form-control" 
                                                    rows="5"
                                                    value={observaciones}
                                                    onChange={(e) => setObservaciones(e.target.value)}
                                                    placeholder=""
                                                />
                                            </div>

                                            <div className="form-group">
                                                <button type="submit" className="btn btn-info mr-2">
                                                    Guardar Presupuesto
                                                </button>
                                                <Link to="/listado-presupuestos" className="btn btn-secondary">
                                                    Cancelar
                                                </Link>
                                            </div>

                                        </form>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </section>
                </div>

                {/* Modal de Éxito */}
                <Modal show={showModalExito} onHide={handleCloseModalExito} centered>
                    <Modal.Header closeButton className="bg-info text-white">
                        <Modal.Title>
                            <i className="fas fa-check-circle mr-2"></i>
                            Presupuesto Guardado
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="text-center py-4">
                        <div className="mb-3">
                            <i className="fas fa-check-circle text-success" style={{ fontSize: '3rem' }}></i>
                        </div>
                        <h5 className="mb-3">Presupuesto guardado exitosamente</h5>
                        <div className="alert alert-info">
                            <strong>Número de Presupuesto:</strong> {numeroPresupuestoCreado}
                        </div>
                    </Modal.Body>

                    <Modal.Footer className="d-flex justify-content-center flex-wrap" style={{ gap: '10px', borderTop: 'none' }}>
                        {/* Botón Factura Electrónica */}
                        <Button 
                            variant="primary" 
                            onClick={() => {
                                handleCloseModalExito();
                                history.push(`/crear-factura?presupuesto=${numeroPresupuestoCreado}`);
                            }}
                            style={{ minWidth: '180px' }}
                        >
                            <i className="fas fa-bolt mr-2"></i>
                            Factura Electrónica
                        </Button>

                        {/* Botón Factura No Electrónica */}
                        <Button 
                            variant="secondary" 
                            onClick={() => {
                                handleCloseModalExito();
                                history.push(`/crear-factura-no-electronica?presupuesto=${numeroPresupuestoCreado}`);
                            }}
                            style={{ minWidth: '180px' }}
                        >
                            <i className="fas fa-file-alt mr-2"></i>
                            Factura No Electrónica
                        </Button>

                        {/* Botón Imprimir */}
                        <Button 
                            variant="info" 
                            onClick={() => {
                                handleCloseModalExito();
                                // Abrir vista previa del presupuesto en nueva ventana
                                const url = `${window.location.origin}/smile/#/vista-previa-presupuesto/${numeroPresupuestoCreado}`;
                                window.open(url, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
                            }}
                            style={{ minWidth: '120px' }}
                        >
                            <i className="fas fa-print mr-2"></i>
                            Imprimir
                        </Button>

                        {/* Botón Volver */}
                        <Button 
                            variant="outline-secondary" 
                            onClick={() => {
                                handleCloseModalExito();
                                history.push('/listado-presupuestos');
                            }}
                            style={{ minWidth: '120px' }}
                        >
                            <i className="fas fa-arrow-left mr-2"></i>
                            Volver
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal para seleccionar paciente */}
                {showModalPaciente && (
                    <div className="modal fade show" style={{display: 'block'}} tabIndex="-1">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Seleccionar Paciente</h5>
                                    <button type="button" className="close" onClick={() => setShowModalPaciente(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <input 
                                            type="text" 
                                            className="form-control" 
                                            placeholder="Buscar por nombre o documento..."
                                            value={busquedaPaciente}
                                            onChange={(e) => {
                                                setBusquedaPaciente(e.target.value);
                                                setPaginaActual(1);
                                            }}
                                        />
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Documento</th>
                                                    <th>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {getPacientesPaginados().map((paciente, index) => (
                                                    <tr key={index}>
                                                        <td>{`${paciente.primer_nombre || ''} ${paciente.segundo_nombre || ''} ${paciente.primer_apellido || ''} ${paciente.segundo_apellido || ''}`.trim()}</td>
                                                        <td>{paciente.numero_documento}</td>
                                                        <td>
                                                            <button 
                                                                type="button" 
                                                                className="btn btn-sm btn-primary"
                                                                onClick={() => seleccionarPaciente(paciente)}
                                                            >
                                                                Seleccionar
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    
                                    {/* Paginación */}
                                    {getTotalPaginas() > 1 && (
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary"
                                                disabled={paginaActual === 1}
                                                onClick={() => setPaginaActual(paginaActual - 1)}
                                            >
                                                Anterior
                                            </button>
                                            <span>Página {paginaActual} de {getTotalPaginas()}</span>
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary"
                                                disabled={paginaActual === getTotalPaginas()}
                                                onClick={() => setPaginaActual(paginaActual + 1)}
                                            >
                                                Siguiente
                                            </button>
                                        </div>
                                    )}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalPaciente(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default CrearPresupuesto;